"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalSystemsClaim = void 0;

var ExternalSystemClaim_1 = require("./ExternalSystemClaim");

var ExternalSystemsClaim =
/** @class */
function () {
  function ExternalSystemsClaim() {}

  ExternalSystemsClaim.prototype.populate = function (pfmExtClaimObject) {
    var _this = this;

    Object.keys(pfmExtClaimObject).forEach(function (code) {
      _this[code] = new ExternalSystemClaim_1.ExternalSystemClaim();
      Object.assign(_this[code], pfmExtClaimObject[code]);
    });
  };

  ExternalSystemsClaim.prototype.getCodes = function () {
    return Object.keys(this);
  };

  ExternalSystemsClaim.prototype.getExternalSystem = function (code) {
    return this[code];
  };

  return ExternalSystemsClaim;
}();

exports.ExternalSystemsClaim = ExternalSystemsClaim;